FiltersMdl.service( 'SubcategoriesHandlerSrv', ['$q', '$http', 'API_URL', 'SubcategoriesFcty', 'HuesSrv', 'HuesUpdaterSrv', function( $q, $http, API_URL, SubcategoriesFcty, HuesSrv, HuesUpdaterSrv ) {
	return new SubcategoriesFcty({

		getItems: function( category_id ) {
			HuesUpdaterSrv.getHues = false;
			if( category_id == this.category.id ) {
				HuesUpdaterSrv.hideHues = true;
			} else {
				HuesSrv.setFilter('search_term', false );
				HuesSrv.setFilter('search_single', false );
				HuesSrv.setFilter('subcategory', category_id );
				HuesUpdaterSrv.hideHues = false;
				HuesUpdaterSrv.getHues = true;
			}




		}
	});
}]);
